import { createStore } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { enableMapSet } from 'immer';
import type { DataSource } from '../../types/data-source';

enableMapSet();

export interface DataSourceStore {
  dataSources: Map<string, DataSource>;
  setDataSource: (dataSource: DataSource) => void;
  setDataSourceValue: (dataSourceName: string, value: any) => void;
  reset: () => void;
}

export const dataSourceStore = createStore<DataSourceStore>()(
  subscribeWithSelector(
    immer((set) => ({
      dataSources: new Map<string, DataSource>([]),
      initialized: false,
      setDataSource: (dataSource: DataSource) =>
        set((draft) => {
          const { name } = dataSource;
          if (name) {
            draft.dataSources.set(name, dataSource);
          }
        }),
      setDataSourceValue: (dataSourceName: string, value: any) =>
        set((draft) => {
          const dataSource = draft.dataSources.get(dataSourceName);
          if (dataSource) {
            dataSource.value = value;
          }
        }),
      reset: () =>
        set((draft) => {
          draft.dataSources.clear();
        }),
    })),
  ),
);
